const doc = [({"en":({"js":({"shared":({"preview":({"preview":"Preview"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;